import { useOperatorFilterModel } from '@features/operator/filterByOperator';
import { initBackboneConnectionFiltersHotels } from '@features/hotel/filterHotels';
import { watch } from 'vue';
import {
    useState, useActions,
} from 'vuex-composition-helpers';
import { IMapForFiltersSerpActions, IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';

export default function () {
    initBackboneConnectionFiltersHotels();
    const {
        setOperatorFilter,
        takenOperators,
    } = useOperatorFilterModel();
    const {
        operators: operatorsBackbone,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['operators']);
    const {
        action_operators: setOperatorsBackbone,
    } = useActions<IMapForFiltersSerpActions>(nameFilterSerpStore, ['action_operators']);

    watch(operatorsBackbone, (value) => {
        setOperatorFilter(value);
    }, { immediate: true });

    watch(takenOperators, (value) => {
        setOperatorsBackbone(value);
    });
}